import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import SideMenu from "../../components/SideMenu";
import LoadingSpinner from "../../components/LoadingSpinner";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import CancelSubModal from "./modals/CancelSubModal";
import RenewSubModal from "./modals/RenewSubModal";
export default function MyOneSubscription() {
  const [subscription, setSubscription] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();
  const [events, setEvents] = useState([]);
  const [cancelSubModal,setCancelSubModal] = useState(false)
  const [renewSub,setRenewSub] = useState(false)


  const billingPortal = async () => {
    try {
      setIsLoading(true);
  
      const billingPortalResponse = await axios.get(
        `${ApiConnectionString}/api/ConnectBillingPortal/${subscription.club.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (billingPortalResponse.status === 200) {
        window.location.href = billingPortalResponse.data;
      }
    } catch (error) {
      console.error("Failed to open billing portal:", error);
    } finally {
      setIsLoading(false);
    }
  };
  






  const cancelModal = () => {
    setCancelSubModal(false)
    setRenewSub(false)
  };

  const fetchData = async () => {
    cancelModal();
    setIsLoading(true);
    try {
      const subResponse = await axios.get(
        `${ApiConnectionString}/api/mysubscription/${id}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (subResponse.status === 200) {
        setSubscription(subResponse.data);
      }

      if (subResponse.data.product.totalAccess == false) {
        const accessResponse = await axios.get(
          `${ApiConnectionString}/api/ProductAccess/${subResponse.data.product.id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        if (accessResponse.status == 200) {
          setEvents(accessResponse.data);
        }
      }

    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching subscription:", error);
      // You can also add error handling logic here, like setting an error state
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="row">
          <div className="col-3 side-menu-container">
            <SideMenu />
          </div>
          <div className="col bg-white mx-5 my-2 p-0 ">
            <div className="blueBanner">
              <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
                My Subscription to: {subscription.club.name}
              </p>
            </div>
            {subscription.status == "past_due" && (
              <div className="border m-4 border-danger rounded p-2">
                <p className="text-danger">
                  A payment is overdue for this subscription. Please press
                  "Amend" to resolve this.
                </p>
                <button
                  onClick={() => {}}
                  className="saveChanges-button"
                >
                  Amend
                </button>
              </div>
            )}
            <div className="row">
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Club</p>
                </div>

                <div className="text-center">
                  <Link
                    className="red-text fw-bold"
                    to={`/club/${subscription.club.id}`}
                  >
                    {subscription.club.name}
                  </Link>
                </div>

                <div className="d-flex justify-content-center">
                  <div className="circle-crop">
                    <img
                      src={
                        subscription.club.image
                          ? `${ApiConnectionString}/api/ClubProfileImage/${subscription.club.id}`
                          : NoImagePlaceholder
                      }
                      alt="Club Image"
                      className="mt-0"
                    />
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Profile</p>
                </div>
                <div className="text-center">
                  {" "}
                  <p className="red-text fw-bold">
                    {subscription.viewBookingProfile.username}
                  </p>
                </div>

                <div className="d-flex justify-content-center">
                  <div className="circle-crop">
                    <img
                      src={
                        subscription.viewBookingProfile.image
                          ? `${ApiConnectionString}/api/profileImage/${subscription.viewBookingProfile.id}`
                          : ProfilePlaceHolder
                      }
                      alt="Club Image"
                      className="mt-0"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Package</p>
                </div>

                <table>
                  <tr>
                    <td className="red-text fw-bold">Club:</td>
                    <td>{subscription.club.name}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">Package: </td>
                    <td>{subscription.product.name}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">Cost: </td>
                    <td>
                      £{subscription.price / 100} per {subscription.interval}
                    </td>
                  </tr>
                </table>
              </div>
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Payment</p>
                </div>

                <table>
                  <tr>
                    <td className="red-text fw-bold">Cardholder: </td>
                    <td>{subscription.viewPaymentMethod.cardHolderName}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">type </td>
                    <td>{subscription.viewPaymentMethod.cardType}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">expiry</td>
                    <td>
                      {subscription.viewPaymentMethod.expMonth}/
                      {subscription.viewPaymentMethod.expYear}
                    </td>
                  </tr>
                  <tr>
                    {" "}
                    <td className="red-text fw-bold">Last4</td>
                    <td>{subscription.viewPaymentMethod.last4}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Settings</p>
                </div>
                <div className="mt-3">
                  <p>
                    You can manage your saved cards, subscriptions, and billing
                    details through your Stripe billing portal.
                  </p>
                  <button
                    className="btn btn-primary mt-2"
                    onClick={billingPortal}
                  >
                    Manage Billing
                  </button>
                </div>
              </div>
              <div className="col">
                <div className="lightBlueBanner">
                  <p>Status</p>
                </div>

                {subscription.cancelPending ? (
                  <div>
                 <p>Status: Cancels on {new Date(subscription.endPeroidDate).toLocaleDateString()}</p>

                    <p>
                      Your subscription is currently set to be canceled. If you
                      wish to continue using the service, you can renew it
                      before the next billing date by clicking the button below.
                    </p>
                    <button className="saveChanges-button" onClick={() => {setRenewSub(true)}}>
                      Renew Subscription
                    </button>
                  </div>
                ) : (
                  <div>
                    {" "}
                    <p>Status : {subscription.status}</p>
                    <p>
                      If you wish to cancel your subscription, click the button
                      below and confirm your choice. Your subscription will
                      remain active until the next billing date. If you change
                      your mind, you can renew it before then.
                    </p>
                    <button className="delete-button" onClick={() => {setCancelSubModal(true)}}>
                      Cancel Subscription
                    </button>
                  </div>
                )}
              </div>
            </div>
            {subscription.product.totalAccess ? (
              <p>This subscription allows access to all classes</p>
            ) : (
              <div>
                <div className="lightBlueBanner mt-3">
                  <p className="mb-0">
                    This subscription allows access to the following classes
                  </p>
                </div>
                <table className="custom-table mt-0">
                  <thead className="blueBanner">
                    <tr>
                      <th>Class</th>
                      <th>Day</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((event) => (
                      <tr key={event.id}>
                        <td>{event.name}</td>
                        <td>{event.day}</td>
                        <td>
                          {event.timeIn} - {event.timeOut}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

{cancelSubModal && <CancelSubModal cancelModal={cancelModal} fetchData={fetchData} id={id}/>}
{renewSub && <RenewSubModal cancelModal={cancelModal} fetchData={fetchData} id={id}/>}
   
      </div>
    );
  }
}
